import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import Button from 'jl-design-system/elements/button/Button';
import CloseButton from 'jl-design-system/elements/icons-jb/Close32PxOutlined';
import SearchIcon from 'jl-design-system/elements/icons-jb/Search32PxOutlined';
import styles from './search-input.scss';

const SearchInput = ({
  id,
  searchTerm,
  setSearchTerm,
  loaded,
  loadSearchBoxFiles,
  setLoaded,
  results,
  container,
  form,
  box,
  features,
  showClear,
  parentOnFocus,
  isTypeaheadOpen,
  isBrandPromiseActive = false,
}) => {
  const placeholderDefaultText = 'Search product or brand';
  const [placeholderText, setPlaceholderText] = useState(
    placeholderDefaultText
  );

  const searchClassNames = classNames(styles.searchInput, {
    [styles.searchInput__active]: isTypeaheadOpen || showClear,
    [styles.searchInput__bp]: isBrandPromiseActive,
    [styles.searchInput__bp__active]: isBrandPromiseActive && isTypeaheadOpen,
  });

  useEffect(() => {
    if (isTypeaheadOpen) {
      setPlaceholderText();
    } else {
      setPlaceholderText(placeholderDefaultText);
    }
  }, [isTypeaheadOpen]);

  return (
    <div
      className={classNames(styles.searchInputContainer, {
        [styles.searchInputContainer__bp]: isBrandPromiseActive,
      })}
      data-testid="search-input-container"
    >
      <div
        className={classNames(styles.searchContainer, {
          [styles.searchContainer__bp]: isBrandPromiseActive,
          [styles.searchContainer__bp__active]:
            isBrandPromiseActive && isTypeaheadOpen,
        })}
      >
        <div className={styles.glassIconContainer}>
          <Button type="submit">
            <SearchIcon color="#141414" />
            <span className={styles.visuallyHidden}>Search</span>
          </Button>
        </div>
        <input
          type="text"
          name="search-term"
          id={id}
          label="Search"
          placeholder={placeholderText}
          maxLength={150}
          autoComplete="off"
          value={searchTerm}
          ref={box}
          onChange={e => {
            setSearchTerm(e.target.value);
          }}
          className={searchClassNames}
          onFocus={() => {
            parentOnFocus();
            if (!loaded) {
              loadSearchBoxFiles(() => {
                // eslint-disable-next-line no-unused-expressions
                typeof window !== 'undefined' &&
                  window.SearchBoxUI.init(
                    results.current,
                    container.current,
                    form.current,
                    box.current,
                    features.monetateExperiences,
                    isBrandPromiseActive,
                    {}
                  );
              });
            }
            setLoaded(true);
          }}
        />
        <div className={styles.closeIconContainer}>
          <Button
            type="reset"
            className={classNames(styles.searchInput__closeIcon, {
              [styles.hide]: !showClear,
            })}
          >
            <CloseButton color="#141414" />
            <span className={styles.visuallyHidden}>Clear</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchInput;
